import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectCustomDigitalFileName,
  selectSkipFavoriteInFileMode,
} from '@ui/products/shopping-cart-back/actions/selector';
import { combineLatest, Observable } from 'rxjs';
import { delay, map, switchMap } from 'rxjs/operators';
import { TranslationLoaderService } from '@ui/nls/translations/translation-loader.service';

@Pipe({
    name: 'fileName',
    standalone: false
})
export class FileNamePipe implements PipeTransform {
  constructor(
    private store: Store,
    private translationLoaderService: TranslationLoaderService,
  ) {}

  transform(isFull: boolean): Observable<
    Array<{
      language: string;
      text: string;
    }>
  > {
    return combineLatest([
      this.store.pipe(select(selectCustomDigitalFileName)),
      this.translationLoaderService.translateAsync(
        'productFront',
        'clivlbk3r000008mj2c1nbdat',
      ),
    ]).pipe(
      delay(100),
      map(([{ customDigitalFileName, useCustomDigitalFileName }]) => {
        if (useCustomDigitalFileName) {
          return customDigitalFileName;
        }
        return [
          {
            text: this.translationLoaderService.translate(
              'productFront',
              'clivlbk3r000008mj2c1nbdat',
            ),
            language: 'pl',
          },
        ];
      }),
    );
  }
}
